module.exports = __webpack_public_path__ + "static/media/girl-9.d16953aa.svg";